import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

// Wordmark "BONESIDE" (logo solid, sem subtítulo) carregado como string e injetado inline,
// pra herdar a cor do tema (currentColor = text.primary) e adaptar ao claro/escuro.
// Asset estático do repositório resolvido em build (`?raw`) — não é conteúdo de usuário,
// por isso é o único `dangerouslySetInnerHTML` do app que dispensa sanitização.
import wordmark from 'assets/images/boneside-wordmark.svg?raw';

interface LogoMainProps {
  reverse?: boolean;
}

export default function LogoMain({ reverse }: LogoMainProps = {}) {
  const theme = useTheme();
  void reverse;
  return (
    <Box
      role="img"
      aria-label="Boneside"
      sx={{
        color: theme.vars!.palette.text.primary,
        display: 'inline-flex',
        '& svg': { height: 22, width: 'auto', display: 'block' }
      }}
      dangerouslySetInnerHTML={{ __html: wordmark }}
    />
  );
}
